import request from './request'
import { SongDetailResponse, LyricsResponse, SimiPlaylistResponse, SimiSongResponse } from '@/types/player-api'

const getSongDetail = (ids): Promise<SongDetailResponse> => {
    return request({
        url: '/song/detail',
        params: {
            ids,
        },
    })
}

const getLyric = (id): Promise<LyricsResponse> => {
    return request({
        url: '/lyric',
        params: {
            id,
        },
    })
}

const getSimiPlaylist = (id): Promise<SimiPlaylistResponse> => {
    return request({
        url: '/simi/playlist',
        params: {
            id,
        },
    })
}

const getSimiSong = (id): Promise<SimiSongResponse> => {
    return request({
        url: '/simi/song',
        params: {
            id,
        },
    })
}

export { getSongDetail, getLyric, getSimiPlaylist, getSimiSong }
